import { create } from 'zustand';

import { BrandLogosProperties } from './BrandExperienceModal';

export interface BrandExperienceModalStore {
  isOpen: boolean;
  callback: (logos: BrandLogosProperties) => void;

  setIsOpen: (
    isOpen: BrandExperienceModalStore['isOpen'],
    meta?: {
      callback: BrandExperienceModalStore['callback'];
    },
  ) => void;

  reset: () => void;
}

export const useBrandExperienceModalStore = create<BrandExperienceModalStore>(
  (set) => ({
    isOpen: false,
    callback: () => {},

    setIsOpen: (isOpen, meta) => {
      set({
        isOpen,
        callback: meta?.callback,
      });
    },

    reset: () => set({ isOpen: false, callback: () => {} }),
  }),
);
